/* Copyright (c) 2017 Backpack Health LLC */

import moment from 'moment';

function setLocale(locale) {
  moment.locale(locale);
}

function today() {
  return moment().format('YYYY-MM-DD');
}

function isBefore(date1, date2, precision = 'day') {
  const mDate1 = moment(date1);
  const mDate2 = moment(date2);
  return mDate1.isBefore(mDate2, precision);
}

function formattedMediumDate(date1, precision1, locale) {
  const mDate = moment(date1);
  mDate.locale(locale);
  if (!date1) {
    return '';
  } else if (precision1 === 'P1Y') {
    return mDate.format('YYYY');
  } else if (precision1 === 'P1M') {
    return mDate.format('MMM YYYY');
  } else {
    return mDate.format('ll');
  }
}

function formattedLongDate(date1, precision1, locale) {
  const mDate = moment(date1);
  mDate.locale(locale);

  if (!date1) {
    return '';
  } else if (precision1 === 'P1Y') {
    return mDate.format('YYYY');
  } else if (precision1 === 'P1M') {
    return mDate.format('MMMM YYYY');
  } else {
    return mDate.format('LL');
  }
}


const DateUtil = {
  setLocale,
  today,
  isBefore,
  formattedMediumDate,
  formattedLongDate,
};

export default DateUtil;
